import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20f7893c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl mb-3 font-bold tracking-tight text-gray-900" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fa fa-folder" }),
    /*#__PURE__*/_createTextVNode(" Folders ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-4 leading-6" }, [
    /*#__PURE__*/_createTextVNode(" Here you can add, delete or edit Folders."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Click on a Folder for details. ")
  ])
], -1))
const _hoisted_4 = { class: "page-container" }
const _hoisted_5 = {
  key: 0,
  class: "w-full h-80 flex justify-center items-center"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = { role: "list" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "aspect-video rounded-t-xl bg-[#17312D]"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-2 left-3 fa-solid fa-grip-vertical text-2xl text-gray-400 h-full my-auto mr-2 cursor-move handle hover:text-gray-600 transition-colors" }, null, -1))
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Courses in folder", -1))
const _hoisted_17 = { role: "list" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "aspect-video rounded-t-xl bg-[#17312D]"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-2 left-3 fa-solid fa-grip-vertical text-2xl text-gray-400 h-full my-auto mr-2 cursor-move handle hover:text-gray-600 transition-colors" }, null, -1))
const _hoisted_22 = { class: "m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditFolderSidebar = _resolveComponent("EditFolderSidebar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Card = _resolveComponent("Card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_ctx.hasAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_EditFolderSidebar, {
          ref: "sidebar",
          onUpdate: $options.calculateFolderContent
        }, null, 8, ["onUpdate"]),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.sidebar.showEmpty($options.currentFolderId))),
              label: "New folder",
              icon: "fa fa-plus-circle"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($data.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Loading, { text: "Fetching folders" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_Breadcrumb, {
                  model: $data.currentPath,
                  class: "mb-4"
                }, {
                  item: _withCtx(({ item }) => [
                    _createElementVNode("a", {
                      onClick: ($event: any) => ($options.popPathUntilFolderId(item.id)),
                      class: "cursor-pointer hover:font-bold"
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1)
                    ], 8, _hoisted_7)
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("ul", _hoisted_9, [
                  _createVNode(_component_draggable, _mergeProps({
                    modelValue: $data.foldersForCurrentFolder,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.foldersForCurrentFolder) = $event)),
                    "item-key": "id",
                    handle: ".handle"
                  }, $options.dragOptionsFolders, {
                    onUpdate: $options.onRearrangedFolders,
                    class: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
                  }), {
                    item: _withCtx(({ element }) => [
                      _createElementVNode("li", null, [
                        _createVNode(_component_Card, {
                          class: "cursor-pointer",
                          onClick: ($event: any) => ($options.navigateToFolder(element))
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              (element.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: element.imageUrl,
                                    class: "rounded-t-xl"
                                  }, null, 8, _hoisted_11))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12)),
                              _createVNode(_component_Button, {
                                onClick: _withModifiers(($event: any) => (_ctx.$refs.sidebar.show(element)), ["stop"]),
                                icon: "fa-solid fa-pen-to-square text-xl",
                                class: "!absolute top-0 right-0"
                              }, null, 8, ["onClick"]),
                              _hoisted_13
                            ])
                          ]),
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(element.title), 1)
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("p", _hoisted_14, _toDisplayString(element.description) + " " + _toDisplayString(element.type), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 16, ["modelValue", "onUpdate"])
                ]),
                ($data.coursesForCurrentFolder.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      ($data.foldersForCurrentFolder.length > 0)
                        ? (_openBlock(), _createBlock(_component_Divider, {
                            key: 0,
                            class: "my-4"
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_16,
                      _createElementVNode("ul", _hoisted_17, [
                        _createVNode(_component_draggable, _mergeProps({
                          modelValue: $data.coursesForCurrentFolder,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.coursesForCurrentFolder) = $event)),
                          "item-key": "id",
                          handle: ".handle"
                        }, $options.dragOptionsCourses, {
                          onUpdate: $options.onRearrangedCourses,
                          class: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
                        }), {
                          item: _withCtx(({ element }) => [
                            _createElementVNode("li", null, [
                              _createVNode(_component_Card, { class: "cursor-pointer" }, {
                                header: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_18, [
                                    (element.imageUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: element.imageUrl,
                                          class: "rounded-t-xl"
                                        }, null, 8, _hoisted_19))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_20)),
                                    _createVNode(_component_Button, {
                                      onClick: _withModifiers(($event: any) => ($options.navigateToCourse(element)), ["stop"]),
                                      icon: "fa-solid fa-up-right-from-square text-xl",
                                      class: "!absolute top-0 right-0"
                                    }, null, 8, ["onClick"]),
                                    _hoisted_21
                                  ])
                                ]),
                                title: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(element.title), 1)
                                ]),
                                content: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_22, _toDisplayString(element.description) + " " + _toDisplayString(element.type), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }, 16, ["modelValue", "onUpdate"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}